import type { NavigateFunction } from 'react-router-dom';

// Bridges non-React modules (services, the toast layer) to the app's router so
// they can navigate client-side instead of triggering a full-page reload. The
// app registers its `navigate` once at mount (see App.tsx <NavigationRegistrar/>).
let navigatorFn: NavigateFunction | null = null;

export const setAppNavigator = (nav: NavigateFunction | null): void => {
  navigatorFn = nav;
};

/**
 * SPA-navigate to a path. Falls back to a hard navigation only if the router
 * isn't mounted yet (e.g. a notification fires before first render).
 */
export const appNavigate = (to: string): void => {
  if (!to) return;
  if (navigatorFn) {
    navigatorFn(to);
  } else {
    window.location.assign(to);
  }
};
